module.exports = __webpack_public_path__ + "img/provider10.275ffe55.png";